<template>
	<section class="pc-card" :style="`background: url(${data.bg}) no-repeat top / 100% 100%;`">
		<div class="info">
			<div class="nickname">{{ teacherInfo?.nickname }}</div>
			<div class="tags" v-if="teacherInfo?.tags.length > 0">
				專長：{{ teacherInfo?.tags.join("、") }}
			</div>
			<div class="desc">{{ teacherInfo.introduce }}</div>
		</div>
		<div class="cs" v-if="csData.length > 0">
			<div class="cs-title">老師推薦測試</div>
			<div class="swiper">
				<div class="swiper-wrapper">
					<div
						class="swiper-slide"
						v-for="item in csData"
						:key="item.id"
						:style="`background-image: url(${data.cs_bg})`"
						@click="toCs(item)"
					>
						<img :src="item.cover_cc || item.cover" />
						<div class="content">
							<p class="title">{{ item.name }}</p>
							<p class="desc">{{ item.description }}</p>
						</div>
					</div>
				</div>
				<div v-if="csData.length >= 3">
					<img class="swiper-button-prev" src="./images/icon-left.png" alt="" />
					<img class="swiper-button-next" src="./images/icon-right.png" alt="" />
				</div>
			</div>
		</div>
	</section>
</template>

<script setup>
import { goLink } from "~/utils/common";
import { logEvent } from "~/utils/firebase";
import { Navigation, Swiper } from "swiper";
import "~/assets/swiper/common-modules.js";
import { watch } from "vue";

const props = defineProps({
	data: {
		type: Object,
		default: () => ({}),
	},
	teacherInfo: {
		type: Object,
		default: () => ({}),
	},
	csData: {
		type: Array,
		default: () => [],
	},
	csEvent: {
		type: String,
		default: "",
	},
	schannel: {
		type: String,
		default: "",
	},
});

const initSwiper = () => {
	new Swiper(".swiper", {
		modules: [Navigation],
		slidesPerView: 3,
		slidesPerGroup: 3,
		loop: true,
		autoplay: {
			delay: 5000,
		},
		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		},
	});
};

watch(
	() => props.csData,
	() => {
		console.log(props.csData);
		if (props.csData.length >= 3) {
			setTimeout(() => {
				initSwiper();
			}, 500);
		}
	},
	{
		immediate: true,
	}
);

const toCs = item => {
	if (import.meta.client) {
		logEvent(props.csEvent);
	}
	goLink(item.jump_url, props.schannel);
};
</script>

<style lang="scss" scoped>
.pc-card {
	display: flex;
	flex-direction: column;
	padding: 158px 0 20px;
	width: 100%;
	height: 812px;
	font-family: PingFang SC;

	.info {
		width: 567px;
		margin-left: 550px;

		.nickname {
			font-weight: 600;
			font-size: 26px;
			color: #333333;
			line-height: 40px;
		}

		.tags {
			margin-top: 5px;
			font-weight: 500;
			font-size: 22px;
			color: #2b2f36;
			line-height: 26px;
		}

		.desc {
			margin-top: 15px;
			font-size: 18px;
			color: #082e2e;
			line-height: 27px;
		}
	}

	.cs {
		margin-top: auto;
		margin-bottom: -33px;

		.cs-title {
			margin-left: 65px;
			margin-bottom: -33px;
			font-weight: 500;
			font-size: 32px;
			color: #1f2329;
			line-height: 45px;
		}

		.swiper {
			padding: 0 53.5px;
		}

		.swiper-slide {
			padding: 61px 21px;
			display: flex;
			width: 391px;
			height: 264px;
			border-radius: 8px;
			background-repeat: no-repeat;
			background-position: center;
			background-size: 471px 264px;
			cursor: pointer;
			position: relative;

			&:after {
				content: "";
				display: block;
				width: 30px;
				height: 30px;
				background: url("./images/icon_jiantou_gray.png") no-repeat center;
				background-size: 100% 100%;
				position: absolute;
				z-index: 99;
				bottom: 58px;
				right: 21px;
			}

			img {
				width: 142px;
				height: 142px;
				border-radius: 5px;
			}

			.content {
				margin-left: 16px;

				.title {
					font-weight: 500;
					font-size: 18px;
					color: #1f2329;
					line-height: 27px;
				}

				.desc {
					margin-top: 10px;
					font-size: 16px;
					color: #646a73;
					line-height: 24px;
					display: -webkit-box;
					-webkit-box-orient: vertical;
					-webkit-line-clamp: 4;
					overflow: hidden;
					text-overflow: ellipsis;
				}
			}
		}

		.swiper-button-prev,
		.swiper-button-next {
			margin: -32px 40px 0;
			width: 40px;
			height: 40px;
		}
	}
}
</style>
